import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "contentContainer"]
  static values = {
    open: Boolean,
    contentSource: String
  }

  connect() {
    if (this.openValue) this.open()
    this.boundBeforeCache = this.beforeCache.bind(this)
    document.addEventListener("turbo:before-cache", this.boundBeforeCache)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.boundBeforeCache)
  }

  open() {
    this.dialogTarget.showModal()
    if (this.contentSourceValue && this.contentContainerTarget) {
      fetch(this.contentSourceValue, {
        headers: {
          Accept: "text/vnd.turbo-stream.html",
        }
      })
        .then((response) => response.text())
        .then((html) => {
          Turbo.renderStreamMessage(html)
        })
    }
  }

  // Allows for a closing animation since display transitions don't work yet
  close() {
    this.dialogTarget.setAttribute("closing", "")

    Promise.all(
      this.dialogTarget.getAnimations().map((animation) => animation.finished),
    ).then(() => {
      this.dialogTarget.removeAttribute("closing")
      this.dialogTarget.close()
    })
  }

  backdropClose(event) {
    event.stopPropagation()
    if (event.target.nodeName == "DIALOG") this.close()
  }

  // For showing non-modally
  show() {
    this.dialogTarget.show()
  }

  hide() {
    this.close()
  }

  preventClose(event) {
    event.stopPropagation()
  }

  beforeCache() {
    this.close()
  }

  handleResponse({ detail: { success } }) {
    if (success) {
      this.close()
    }
  }
}
